import { ActionTypes } from "../contants/action-type.js";
import {
    getCategories,
    createCategory,
    updateCategory,
    deleteCategory,
    getSelectedCategory,
    changeStatusCategory,
    getCategoryType
} from '../../services/CategoryService.js';

export function getCategoryAction() {
    return (dispatch, getState) => {
        getCategories().then((response) => {
            dispatch(listCategories(response.data));
        });
    };
}
export function getSelectedCategoryAction(id) {
    return (dispatch, getState) => {
        getSelectedCategory(id).then((response) => {
            dispatch(selectedCategory(response.data));
        });
    };
}

export function getCategoryTypeAction() {
    return (dispatch, getState) => {
        getCategoryType().then((response) => {
            dispatch(selectedCategoryType(response.data));
        });
    };
}

export function createCategoryAction(category, closeSidebar) {
    return (dispatch, getState) => {
        createCategory(category)
            .then((response) => {
                dispatch(confirmCreateCategory(response?.data));
                // console.log(history)
                // history.push('/menu');
                closeSidebar()
            });
    };
}



export function updateCategoryAction(category, id, closeSidebar) {
    return (dispatch, getState) => {
        console.log(category);
        updateCategory(category, id).then((response) => {
            dispatch(confirmEditCategory(response.data));
           // history.push('/item/category');
            closeSidebar()
        });
    };
}
export function changeStatusCategoryAction(category, id, history) {
    return (dispatch, getState) => {
        changeStatusCategory(category, id).then((response) => {
            dispatch(listCategories(response.data));
            history.push('/item/category');
        });
    };
}
export function deleteCategoryAction(id, history) {
    return (dispatch, getState) => {
        deleteCategory(id).then((response) => {
            console.log(response);
            dispatch(listCategories(response.data));
            history.push('/item/category');
        });
    };
}
export const listCategories = (categories) => {
    return {
        type: ActionTypes.LIST_CATEGORY,
        payload: categories
    }
}
export const confirmCreateCategory = (category) => {
    return {
        type: ActionTypes.CONFIRM_CREATE_CATEGORY,
        payload: category
    }
}
export const confirmEditCategory = (category) => {
    return {
        type: ActionTypes.CONFIRM_EDIT_CATEGORY,
        payload: category
    }
}
export const selectedCategory = (category) => {
    return {
        type: ActionTypes.SELECTED_CATEGORY,
        payload: category
    }
}

export const selectedCategoryType = (categoryType) => {
    return {
        type: ActionTypes.SELECTED_CATEGORY_TYPE,
        payload: categoryType
    }
}


export const confirmDeleteCategory = (category) => {
    return {
        type: ActionTypes.CONFIRM_DELETE_CATEGORY,
        payload: category
    }
}